export default "__VITE_PUBLIC_ASSET__5429c4c7__"